import React, { FC } from 'react';
import { useAppState } from 'src/shared/appState';
import { EmptyMessage } from 'src/shared/globals';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ProductProvider } from '../1-addProduct/__generated__/addProductQuery.graphql';
import { Price, renderRange } from './helpers';
import { Input } from '../../../../widgets/input';
import { Row, Table, TableHeading } from '../../../../widgets/table';

const ProfitInput = styled(Input)`
    width: 100px;
`;

interface PricesTableProps {
    prices: Price[];
    profit: string;
    onProfitChange: (profit: string) => void;
    provider: ProductProvider;
}

const PricesTable: FC<PricesTableProps> = ({ prices, profit, onProfitChange, provider }) => {
    const { state } = useAppState();

    const headings = [
        [T._('SIZE', 'Admin'), '1fr'],
        [provider + ' ' + T._('PRICE', 'Admin'), '1fr'],
        [T._('RETAIL PRICE', 'Admin'), '1fr'],
        [T._('PROFIT', 'Admin'), '1fr']
    ] as TableHeading[];

    return (
        <>
            <Table headings={headings}>
                {prices.length > 0 && (
                    <Row
                        cells={[
                            prices[0].size + ' - ' + prices[prices.length - 1].size,
                            renderRange(
                                Math.min.apply(
                                    this,
                                    prices.map((x) => x.priceMin)
                                ),
                                Math.max.apply(
                                    this,
                                    prices.map((x) => x.priceMax)
                                ),
                                state.priceFormatter
                            ),
                            renderRange(
                                Math.min.apply(
                                    this,
                                    prices.map((x) => x.retailMin)
                                ),
                                Math.max.apply(
                                    this,
                                    prices.map((x) => x.retailMax)
                                ),
                                state.priceFormatter
                            ),
                            <div>
                                <ProfitInput
                                    type='text'
                                    step='1'
                                    min={0}
                                    value={profit}
                                    onChange={(e) => {
                                        if (!Number.isNaN(parseInt(e.currentTarget.value))) {
                                            onProfitChange(e.currentTarget.value.replace(/[^0-9]*/g, ''));
                                        } else {
                                            onProfitChange(e.currentTarget.value);
                                        }
                                    }}
                                />{' '}
                                %
                            </div>
                        ]}
                    />
                )}

                {prices.map((price) => (
                    <Row
                        key={price.size}
                        cells={[
                            price.size,
                            renderRange(price.priceMin, price.priceMax, state.priceFormatter),
                            state.priceFormatter.format(price.retailMax),
                            renderRange(price.retailMin - price.priceMin, price.retailMax - price.priceMax, state.priceFormatter)
                        ]}
                    />
                ))}
            </Table>

            {prices.length == 0 && <EmptyMessage>{T._('No variants selected', 'Admin')}</EmptyMessage>}
        </>
    );
};

export default PricesTable;
